import { UserState } from './types';
import { createSelector } from 'reselect';

export const getUser = (state): UserState => state.user;
export const getIdentityId = (state) => getUser(state)?.user?.identityId;
export const getUserTimeZone = (state): string => state.user && state.user.user && state.user.user.timeZone;
export const customerIdSelector = (state): UserState['currentCompany'] => state.user.currentCompany;

/** Do not use directly. Use access rights hook */
export const isPlatformAllowedSelector = (state) => {
    const isPlatformAllowed = (features: string[], strict = true): boolean => {
        const fn = strict ? 'every' : 'some';

        return features[fn]((feature) => state.user.accessibleFeatures.includes(feature));
    };

    return { isPlatformAllowed, dep: state.user.accessibleFeatures };
};

export const isBynderScopeAllowedSelector = createSelector(
    (state) => state.user?.bynderScopes,
    (bynderScopes) => {
        return (scopes: string[]): boolean =>
            Array.isArray(bynderScopes) && scopes.some((scope) => bynderScopes.includes(scope));
    },
);

/** Do not use directly. Use access rights hook */
export const isAccountRoleAssignedSelector = createSelector(
    (state) => state.user?.roles,
    (roles) => {
        return (role: string): boolean => {
            if (roles) {
                return roles.includes(role);
            }
            return false;
        };
    },
);

export const getFonts = (state: { user: UserState }) => getUser(state).fonts;
export const getElementsFonts = (state: { user: UserState }) => getUser(state).elementsFonts;

export const getSplitFeatures = (state: { user: UserState }) => state.user.splitFeatures;
